import { PATH } from '../../constants/path';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';
import { REQUEST_GOOGLE_PAY, SUCCESS_GOOGLE_PAY, FAILURE_GOOGLE_PAY } from './constants';

import { CALL_API } from '../../middlewares/api';

export function submitGooglePay(googleToken, userInfo, partnerId, orderId) {
    return {
        [CALL_API]: {
            endpoint: '/payment-solution/google/pay',
            method: HTTP_METHOD_POST,
            body: { ...userInfo, partnerId, orderId, googleToken },
            types: [REQUEST_GOOGLE_PAY, SUCCESS_GOOGLE_PAY, FAILURE_GOOGLE_PAY],
            successCallback: response => {
                const { widgetLink } = response.payload;
                window.location.href = widgetLink;
            },
            errorCallback: response => {
                const errorUrl = `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}&code=${response.status}`;
                window.location.href = errorUrl;
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/googlepay/actions.js